import { ShipmentDtoShipmentStatus as ShipmentStatus } from '@uturn/api/v2';
import { shipmentStatusName } from '@uturn/portal/modules/shipments/utils';
import { Badge, type BadgeProps, cn } from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';

/**
 * Coloured shipment-status pill. Each status maps to a brand status-role Badge
 * variant (brand book p.70): yellow = needs action, Water = moving, Container =
 * waiting on you, greyscale = not started / done.
 */
const statusVariant: Record<ShipmentStatus, BadgeProps['variant']> = {
	CONCEPT: 'idle', // Draft — not started
	UNKNOWN: 'idle',
	CANCELLED: 'idle', // terminal — muted
	PUBLISHED: 'action', // needs action
	QUOTED: 'action',
	CARRIER_ASSIGNED: 'moving', // moving
	COST_DECLARED: 'destructive', // waiting on you (Container red)
	EXECUTED: 'done', // done
	COMPLETED: 'done',
};

export const ShipmentStatusBadge = ({
	status = ShipmentStatus.UNKNOWN,
	className,
}: {
	status?: ShipmentStatus;
	className?: string;
}) => {
	const { t } = useTranslation();

	return (
		<Badge variant={statusVariant[status]} className={cn('uppercase', className)}>
			{shipmentStatusName(t)[status]}
		</Badge>
	);
};
